import Link from 'next/link';
import React from 'react';
import { SIZE } from 'app/ui-components/typography/PlayText/PlayText';
import { StyledCategories, CategoryHeading, CategoryList, CategoryLink, Category } from './Categories.styles';

export const Categories = ({ categories }) => (
    <StyledCategories>
        <CategoryHeading>Genrer</CategoryHeading>
        <CategoryList>
            {categories &&
                categories.map((category, i) => {
                    // Next.js redirects only works server side
                    const link = ['teckensprak', 'syntolkat'].includes(category.id)
                        ? `/${category.id}`
                        : `/genre/${category.id}`;

                    return (
                        <Category key={`category-${i}`} data-rt="details-page-genre-link">
                            <Link href={link} passHref>
                                <CategoryLink to={link} size={SIZE.MINI}>
                                    {category.heading}
                                </CategoryLink>
                            </Link>
                        </Category>
                    );
                })}
        </CategoryList>
    </StyledCategories>
);
export default Categories;
